import React from 'react';
import './blockStyle.css';
import { FirmwareType, UpdateStatus } from '../types';
// `ОБН.3`: подписи изделий — из общей таблицы фронта.
import { productTitle } from '../firmwareProducts';

interface FirmwareUpdateBlockProps {
  type: FirmwareType;
  currentVersion?: string;
  firmwares: Array<{ id: number; version: string }>;
  selectedId: number | null;
  onIdChange: (id: number) => void;
  file: File | undefined;
  uploading: boolean;
  onFileChange: (file: File) => void;
  onUpload: () => void;
  onStartUpdate: () => void;
  disabledUpdate: boolean;
  isUpdating: boolean;
  updateStatus?: UpdateStatus;
  // `ОБН.3` (`АРХ-Н25`): изделие образа — обязательный выбор при загрузке.
  products?: string[];
  product?: string;
  onProductChange?: (product: string) => void;
}

const FirmwareUpdateBlock: React.FC<FirmwareUpdateBlockProps> = ({
  type,
  currentVersion = '',
  firmwares,
  selectedId,
  onIdChange,
  file,
  uploading,
  onFileChange,
  onUpload,
  onStartUpdate,
  disabledUpdate,
  isUpdating,
  updateStatus,
  products = [],
  product = '',
  onProductChange
}) => {
  return (
    <div className="FW-update-block">
      <h3>{type} Firmware</h3>
      <div className="FW-field-row">
        {type !== 'AC_control'
          ? <div className="FW-field">
            <label>текущая версия</label>
            <input value={currentVersion} readOnly />
          </div>
          : null}

        {products.length > 0 ? <div className="FW-field">
          <label>изделие</label>
          <select
            className="FW-product-select"
            value={product}
            onChange={(e) => onProductChange?.(e.target.value)}
          >
            <option value="">выбрать</option>
            {products.map((item) => (
              <option key={item} value={item}>
                {productTitle(item)}
              </option>
            ))}
          </select>
        </div> : null}

        <div className="FW-field">
          <label>версии</label>
          <select
            value={selectedId || ''}
            onChange={(e) => {
              const id = Number(e.target.value);
              if (!isNaN(id)) onIdChange(id);
            }}
          >
            <option value="">выбрать</option>
            {firmwares.map((fw) => (
              <option key={fw.id} value={fw.id}>
                {fw.version}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="FW-flex">
        <label
          className="FW-upload-button"
          data-content={file ? file.name : 'Файл не выбран'}
        >
          Выбрать прошивку -
          <input
            type="file"
            accept=".bin"
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (file) onFileChange(file);
            }}
          />
        </label>

        <button
          onClick={onUpload}
          disabled={!file || uploading || (products.length > 0 && !product)}
        >
          {uploading ? 'Загрузка...' : 'Загрузить'}
        </button>
        <button
          onClick={onStartUpdate}
          // disabled={disabledUpdate || isUpdating}
          className="FW-update-button"
        >
          {isUpdating ? 'Обновление...' : 'Обновить'}
        </button>
      </div>
    </div>
  );
};

export default FirmwareUpdateBlock;
